<template>
  <div id="turfcalc"></div>
</template>

<script>
const axios = require("axios").default;
import { mapState } from "vuex";
import turflineIntersect from "@turf/line-intersect";
import turfdistance from "@turf/distance";

//Import the entire turf library
//import * as turf from "@turf/turf";

export default {
  props: {
    refreshStats: {
      type: Boolean
    },
    markerList: {
      type: Array
    }
  },
  computed: {
    ...mapState(["uiRouteType"])
  },
  data() {
    return {
      someMethodWithAReturnValue: "HI"
    };
  },
  watch: {
    async refreshStats() {
      const rawResponse = await axios.get(
        "../map/geojson/GH_AvoidArea_minify.geojson"
      );
      const HSRoads = rawResponse.data;
      let markersWithRoutes = this.markerList.filter(
        e => this.markerList.indexOf(e) > 0
      );

      //Only display the source that is currently active
      let routeType = this.uiRouteType == "Safe" ? "safe" : "risky";

      markersWithRoutes.map(e => {
        let marker = e;
        marker.warning = {};

        let currentRoute = marker.gh[routeType].paths[0].points;
        // console.log("marker");
        // console.log(marker);
        // console.log("current route");
        // console.log(currentRoute);
        // console.log("hi stress");
        // console.log(HSRoads);

        let currentIntersects = turflineIntersect(currentRoute, HSRoads);
        // console.log("current intersections:", currentIntersects);

        //Route can cross High Stress road multiple times in a small clustered space
        //(i.e. a route cross 4 times: in-out in-out on a two lane road)
        //I need to delete that excess of four crossings down to 1 (the first crossing)
        //Remove excess clusters of intersect-points when the geojson pathway
        // has multiple crossings with high-stress road in a tight space.
        if (currentIntersects.features.length > 1) {
          currentIntersects = this.trimIntersects(currentIntersects);
        }

        //Finally, if intersects exist save them to the marker.
        if (currentIntersects !== "undefined") {
          let multipointgeojson = {
            type: "geojson",
            data: {
              type: "Feature",
              geometry: {
                type: "MultiPoint",
                coordinates: []
              }
            }
          };
          // console.log(multipointgeojson)
          // console.log(currentIntersects)
          currentIntersects.features.forEach(geojson => {
            multipointgeojson.data.geometry.coordinates.push(
              geojson.geometry.coordinates
            );
          });

          marker.warning[routeType] = multipointgeojson;
        }
      });
      console.log("emit first");
      this.$emit("toggleTurfCirclesBoolean");
    }
  },
  methods: {
    /**
     * Example below to explain the nested for loops:
     * the 1st for loop moves up the x up through the array
     * the 2nd for loop moves down the array checking each turf-distance against *
     *  -- * 0 0 0 ------- 0 ----- 0 0 ---   start at * and iterate through 0's starting at the end.
     *  -- X ------------- * ----- 0 0 ---   3 deleted (via splice). now at *. ignore X (behind you and technically already checked in prior step), and iterate through o
     *  -- X ------------- X ----- * 0 ---   none deleted. now at *. ignore X's.
     *  -- X ------------- X ----- X -----   1 deleted. Now complete
     */
    // todo - refactor to O(n) from (n^2) - https://medium.com/swlh/javascript-remove-duplicates-from-sorted-array-in-place-d3d959fb4d77
    trimIntersects(intersect) {
      let options = { units: "kilometers" }; //can be degrees, radians, miles, or kilometers
      intersect.features.forEach(point => {
        for (
          let k = intersect.features.length - 1;
          k > intersect.features.indexOf(point);
          k--
        ) {
          let comparePoint = intersect.features[k];
          let distance = turfdistance(point, comparePoint, options);
          if (distance < 0.05) {
            intersect.features.splice(k, 1);
          }
        }
      });
      return intersect;
    }
  }
};
</script>

<style lang="scss" scoped></style>
